import { createApp } from 'vue'
import App from './App'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import store from './store'
import router from './router'
import '@/styles/index.scss' // global css
import icon from '@/icons/index' // icon
import '@/permission' // permission control
import VueForm from '@lljj/vue3-form-element'
import globalComponents from './views/indicatrix/components/globalComponents'
//import '@/permission'
createApp(App)
    .use(router)
    .use(store)
    .use(ElementPlus)
    .use(VueForm)
    .use(icon)
    .use(globalComponents)
    .mount('#app')
